import { render, staticRenderFns } from "./PetListView.vue?vue&type=template&id=3dfaa0dd&scoped=true"
import script from "./PetListView.vue?vue&type=script&lang=js"
export * from "./PetListView.vue?vue&type=script&lang=js"
import style0 from "./PetListView.vue?vue&type=style&index=0&id=3dfaa0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfaa0dd",
  null
  
)

export default component.exports